export default __webpack_public_path__ + "static/jordan-83bdbb2ded2de988041afe95dc8952c5.jpg";